import SubHeaders from '@/components/Headers/SubHeaders'
import TabModules from '@/components/TabModules'
import { ModuleProps } from '@/components/TabModules/Module'
import useTabModules from '@/hooks/useTabModules'
import DnsIcons from '@/icons/DnsIcons'
import WorldPublicIcons from '@/icons/WorldPublicIcons'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import ServiceAnalytic from './ServiceAnalytics'
import { useMemo } from 'react'

interface ModuleConfig {
    icon: JSX.Element
    label: string
    value: string
    productGroupName: string
}

const moduleConfigs: ModuleConfig[] = [
    {
        icon: <WorldPublicIcons className="text-primary" />,
        label: 'content-delivery-network',
        value: '',
        productGroupName: 'Content Delivery Network',
    },
    {
        icon: <DnsIcons className="text-primary" />,
        label: 'vnis',
        value: 'vnis',
        productGroupName: 'VNIS',
    },
]
const Analytics = () => {
    const { t } = useTranslation()

    // Create modules with components that will be recreated when needed
    const modules: ModuleProps[] = useMemo(
        () =>
            moduleConfigs.map((config) => ({
                icon: config.icon,
                label: config.label,
                value: config.value,
                component: <></>, // We'll handle component rendering separately
            })),
        []
    )

    const { TabProps, activeTab } = useTabModules({ modules })

    // Find current module config and render component dynamically
    const currentModuleConfig = moduleConfigs.find(
        (config) => config.value === activeTab
    )
    const CurrentComponent = currentModuleConfig ? (
        <ServiceAnalytic
            key={`${currentModuleConfig.value}-${currentModuleConfig.productGroupName}`}
            productGroupName={currentModuleConfig.productGroupName}
        />
    ) : null

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.reportAnalytics,
                        title: t('report-analytics'),
                    },
                ]}
            />
            <TabModules {...TabProps} />
            {CurrentComponent}
        </>
    )
}

export default Analytics
